<template>
  <v-container>
    <app-page-card :isInModal="isInModal" :isHeaderFixed="isHeaderFixed">
      <template #header >
        Alta/Modificación de {{objectName}}{{thirdName||thirdCif ? ': ' : '' }}<span v-if="thirdName || thirdCif" class="creation-object__title__company-name">{{thirdName}} ({{thirdCif}})</span>
      </template>
      <template slot="tabs-title">
        <slot name="tabs-title" />
      </template>
      <template #header-actions>
        <v-toolbar flat dense>
          <app-btn 
            outlined v-if="isInModal" 
            @click.native.stop="$emit('cancel')"
            class="mr-2 btn-cancel"
          >
            Cancelar
          </app-btn>
          <app-btn
            v-if="id"
            color="primary"
            class="btn-save"
            :loading="creating"
            @click.native.stop="preUpdateObject()"
            v-show="!hideSaveBtn"
          >
            Guardar
          </app-btn>
          <app-btn
            v-else
            color="primary"
            class="btn-create"
            :loading="creating"
            @click.native.stop="createObject()"
          >
            Guardar
          </app-btn>
        </v-toolbar>
      </template>
      <v-progress-circular v-if="loading"
        indeterminate
        color="primary">
      </v-progress-circular>
      <v-container fluid v-else>
        <slot name="inputs"></slot>    
      </v-container>
      <v-snackbar
        v-model="snackbar"
      >
        Se han guardado los cambios
        <v-btn
          text
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </v-snackbar>
    </app-page-card>
    <app-confirm-modal
        v-model="applyChangesAllDocsDialog"
        :text-msg="applyChangesAllDocsMsg"
        :text-question="applyChangesAllDocsQtn"
        text-confirm-button="Aplicar"
        text-cancel-button="No aplicar"
        @confirm="answerApplyChangesAllDocs(true)"
        @cancel="answerApplyChangesAllDocs(false)"
    >
    </app-confirm-modal>
  </v-container>
</template>

<script>
import AppBtn from '@/components/layout/AppBtn.vue';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import {mapGetters, mapState, mapActions} from "vuex"
import { client } from "@/api/client";
import DocTextField from "./DocTextField.vue"
import { createHelpers } from 'vuex-map-fields';
import { mapFields as docMapFields } from 'vuex-map-fields';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import { CountThirdDocsPendingCommand } from "../modules/invoices/app/CountThirdDocsPendingCommand";
import { sync_command_dispatcher} from "@/api/client";
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateScreenValues',
});

function getFirstError(errors){
  Object.keys(errors).forEach((e)=>{
    errors[e]=errors[e][0]
  })
  return errors
}

export default {
  name: 'CreationObject',
  components:{
    AppBtn,
    AppPageCard,
    DocTextField,
    AppConfirmModal,
  },
  props: {
    objectType: {
      type: String,
      required: true
    },
    objectName: {
      type: String,
      required: false,
      default: ''
    },
    url: {
      type: String,
      required: true
    },
    id: {
      type: [String, Number],
      required: false
    },
    inputs: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    company_name: {
      type: String,
      default: "",
    },
    company_nif: {
      type: String,
      default: "",
    },
    screenValue: {
      type: String,
      required: false,
      default: "",
    },
    areParamsChanged: {
      type: Boolean,
      required: false,
      default: false,
    },
    isInModal: {
      type: Boolean,
      default: false,
    },
    isHeaderFixed: {
      type: Boolean,
      required: false,
      default: false,
    },
    thirdName: {
      type: String,
      required: false,
      default: ''
    },
    thirdCif: {
      type: String,
      required: false,
      default: ''
    },
    hideSaveBtn: {
      type: Boolean,
      default: false,
    },
    document_id: {
      type: [String, Number],
      required: false,
      default: null
    },
  },
  data() {
    return {
      panel: [0],
      snackbar: false,
      creating: false,
      valid: false,
      inputs_values: {},
      loading: false,
      companies: [],
      errors: {},
      applyChangesAllDocsDialog: false,
      applyChangesAllDocsMsg: "El tercero tiene documentos pendientes de contabilizar.",
      applyChangesAllDocsQtn: "¿Deseas aplicar los cambios a los documentos pendientes de contabilizar?",
      applyChangesAllDocsMsgDocScreen: "El tercero tiene otros documentos pendientes de contabilizar.",
      applyChangesAllDocsQtnDocScreen: "¿Deseas aplicar los cambios a los otros documentos?",
      applyChangesAllDocs: false,
    };
  },
  
  computed:{
    ...mapState(['currentCompany', 'session_information']),
    ...mapGetters({
      get_retention_types: 'get_retention_types',
      get_automatic_payment_account_types: 'get_automatic_payment_account_types',
      me: "me/userData",
      got_feature: 'got_feature',
    }),
    ...mapFields('cru',['screenValues', 'screenErrors']),
    ...docMapFields('documents', ['selectedParam', 'selectedParamOption', 'selectedParamOption2', 'isBienInversionChanged']),
    retentionTypesItems: function() {
      return this.get_retention_types;
    },
    automaticPaymentAccountTypesItems: function(){
      return this.get_automatic_payment_account_types;
    },

  },
  methods:{
    ...mapActions(["waitForLoggedIn"]),
    ...mapActions({
      getCruData: "cru/getData",
      createCru: "cru/createObject",
      updateCru: "cru/updateObject",
      getErrorsCru: "cru/getErrors",
      getCountriesList: "countries/getCountries",
    }),

    createObject() {
      if (this.objectType == 'Customer' || this.objectType == 'Supplier') {
        this.createCru({'url': this.url, 'currentCompany': this.currentCompany,'userData':this.me}).then(response => {
          this.snackbar=true
          this.name=""
          this.creating=false;
          this.$emit('createdObject', response.data)
        }).catch((e)=>{
          this.creating=false
        });

      } else {
        this.creating=true;
        this.screenValues[this.screenValue]['companydb'] = this.currentCompany['id'];
        client.post(this.url, this.screenValues[this.screenValue]).then(() => {
          this.snackbar=true
          this.name=""
          this.creating=false
        }).catch(err=>{
          this.creating=false
        });        
      }
    },
    preUpdateObject() {
      this.getErrorsCru({'currentCompany': this.currentCompany, 'userData':this.me, 'action': 'update'}).then(response => {
        let errors = response;
        if (Object.keys(errors).length == 0 && this.got_feature('feature_apply_third_changes_doc')) {
          //Revisamos si hay docs pendientes del mismo tercero
          let third_id = this.id;
          let third_kind = this.objectType.toLowerCase();
          new CountThirdDocsPendingCommand(sync_command_dispatcher, this).run(third_id, third_kind).then(response => {
            let count_docs = response.output.count;
            let limit = 0;
            //Si se edita el tercero por la pantalla del documento.
            if (this.$router.currentRoute.name == 'document-detail') {
              limit = 1;
              this.applyChangesAllDocsMsg = this.applyChangesAllDocsMsgDocScreen;
              this.applyChangesAllDocsQtn = this.applyChangesAllDocsQtnDocScreen
            } 
            if (count_docs > limit) {
              //Si hay documentos, preguntamos en popup si aplicar los cambios del tercero.
              this.applyChangesAllDocsDialog = true;
            }
            else {
              this.updateObject();
            }
          }).catch(error => {
              console.error(error);
          });
        }
        else {
          this.updateObject();
        }
      }).catch(error => {
          console.error(error);
      });
    },
    answerApplyChangesAllDocs(apply) {
      this.applyChangesAllDocs = apply;
      this.applyChangesAllDocsDialog = false;
      this.updateObject();
    },
    updateObject() {
      this.creating=true;
      this.updateCru({'id': this.id, 'url': this.url, 'currentCompany': this.currentCompany,'userData':this.me, 'applyChangesAllDocs': this.applyChangesAllDocs, 'document_id': this.document_id}).then(response => {
        this.snackbar=true
        this.creating=false
        this.$emit('createdObject', response.data)
        if (this.areParamsChanged) {
          if (response.data.inversion_sujeto_pasivo_iva) {
            this.selectedParam = 'inversion_sujeto_pasivo_iva';
            this.selectedParamOption = response.data.inversion_sujeto_pasivo_iva_percent;
          } else if (response.data.inversion_sujeto_pasivo_igic) {
            this.selectedParam = 'inversion_sujeto_pasivo_igic';
            this.selectedParamOption = response.data.inversion_sujeto_pasivo_igic_percent;
          } else if (response.data.intracomunitario) {
            this.selectedParam = 'intracomunitario';
            this.selectedParamOption = response.data.intracomunitario_percent;
            this.selectedParamOption2 = response.data.intracomunitario_type;
          } else if (response.data.extracomunitario) {
            this.selectedParam = 'extracomunitario';
            this.selectedParamOption = response.data.importaciones_percent;
          } else if (response.data.no_sujeta) {
            this.selectedParam = 'no_sujeta';
            this.selectedParamOption = undefined;
          }else if (response.data.dry_0_percent) {
            this.selectedParam = 'dry_0_percent';
            this.selectedParamOption = undefined;
          }  
          else{
            this.selectedParam = undefined;
            this.selectedParamOption = undefined;
          }
        }
      }).catch(err=>{
        this.creating=false
      }); 
    },
    getData() {
      this.loading = true;
      this.getCruData({'id': this.id, 'url': this.url, 'nif': this.company_nif, 'name': this.company_name}).then(response => {
        this.loading = false;
      }).catch(err=>{
        this.loading = false;
      });
    },
    getInitialData() {
      this.getData();
      this.getCountriesList();
    },
  },
  async mounted() {
    let isLogged=await this.waitForLoggedIn();
    if(isLogged){
      this.getInitialData();
    }
  },
};
</script>

<style>
.title-color {
    color:#663399;
}
</style>
<style scoped>
.index-input {
    position: relative; 
    z-index: 100000
}
.btn-save, .btn-cancel, .btn-create {
  font-size: 1.25rem; 
}

.creation-object__title__company-name {
  color: #56565B;
  font-size: 20px;
  font-weight: 300; 
  overflow-wrap: normal;
  word-break: normal;
  hyphens: none;
}


</style>
